import { MASTER_RESTAURANT_ID } from '@/config/global/roles';
import { RESTAURANT_USER_ROLE, useAuthContext } from '@durma-soft/gros-sdk';

export const useIsSuperadmin = () => {
  const { user } = useAuthContext();

  return Boolean(
    user &&
    user.restaurant &&
    user.restaurant.id === MASTER_RESTAURANT_ID &&
    user.restaurant.role === RESTAURANT_USER_ROLE.OWNER,
  );
};
